import { render, staticRenderFns } from "./adGroup.vue?vue&type=template&id=b0bf337a&scoped=true&"
import script from "./adGroup.vue?vue&type=script&lang=js&"
export * from "./adGroup.vue?vue&type=script&lang=js&"
import style0 from "./adGroup.vue?vue&type=style&index=0&id=b0bf337a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bf337a",
  null
  
)

export default component.exports